/**
 * Page to list CCs on file.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import ServerError from '../ui/ServerError';

import PropTypes from 'prop-types';
import { Button, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, 
        Snackbar, SnackbarContent, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import PaymentSourceDialog from '../ui/PaymentSourceDialog';
import TaskTypeCCWrapper from './TaskTypeCCWrapper';
import FundingSourceTile from './FundingSourceTile';
import { format } from 'date-fns';

import CheckCircle from '@mui/icons-material/CheckCircle';
import CancelCircleOutline from '@mui/icons-material/Cancel';
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import ReportProblem from '@mui/icons-material/ReportProblem';

import Add from '@mui/icons-material/Add';

import LoadingSpinner from '../ui/LoadingSpinner';
import AccountInformationFetch from './AccountInformationFetch';

import { red, yellow, green } from '@mui/material/colors';

import classNames from 'classnames';
const abEnvironment = new AbEnvironment();

const CCOnFileListQuery = graphql`
query CCOnFileListQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountName
    accountType
    accountStatus
    ccOnFileTsByAccountId(orderBy:CC_ORDER_ASC) {
      totalCount
      nodes {
        accountId
        ccId
        ccStatus
        ccBrand
        ccLast4
      	ccExpy
        ccPan
        ccCvv
        firstName
        lastName
        email
        address1
        address2
        city
        state
        country
        postalCode
        created
      }
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    marginTop: 16,
  },
  divider: {
    marginTop: 4,
    marginBottom: 20,
  },
  sectionBlock: {
    marginBottom: 12,  
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  },
  tblHeadCell: {
    textAlign: 'left',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblHeadCellR: {
    textAlign: 'right',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblHeadCellN: {
    textAlign: 'center',
    verticalAlign: 'bottom',
    borderBottom: 0,
    width: 32,
  },
  tblHeadRow2: {
    height: 24,
  },
  tblHeadCell2: {
    textAlign: 'center',
    verticalAlign: 'top',
    //borderBottom: 0,
  },
  tblHeadRow3: {
    height: 32,
  },
  tblCellWidth100: {
    width: 100,
  },
  tblCellN: {
    width: 32,
    paddingRight: 4,
    paddingLeft: 4,
  },
  tblCellPriority: {
    paddingRight: 4,
    paddingLeft: 4,
  },
  iconbutton: {
    height: 28,
    width: 28,
  },
  iconbuttonicon: {
    marginTop: -10,
  },
  nonMenuStatus: {
    minWidth: 64
  },
  priorityGrid: {
    marginLeft: 14,
  },
  upbutton: {
    marginLeft: -17,
    //marginTop: 0,
    //marginBottom: -10,
  },
  priorityNum: {
    marginTop: -20,
    marginBottom: -10,
  },
  downbutton: {
    marginLeft: -17,
    //marginTop: -20,
    marginBottom: -10,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    backgroundColor: theme.palette.error.light,
  },
});

class CCOnFileList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountFetched: false,
      addressFilled: false,
      primaryContactFilled: false,
      resellerName: '',

      contactFirstName: '',
      contactLastName: '',
      contactEmail: '',
      contactEmailValid: null,
 
      country:    '',
      state:      '',
      city:       '',
      postalCode: '',
      address1:   '',
      address2:   null,
      showSpinner: false,

      dialogOpen: false,
      resellerName: '',
      rowMenuClicked: '',
      activeMenu: null,
      rowStatus: null,
      refreshCount: 0,

    };  
  }

  componentDidMount() {
 
    const { logError } = this.props.auth;

    let accountId = this.props.accountId
    
    AccountInformationFetch.fetch(accountId).toPromise()
    .then(aif => {
        var addressFilled = false;
        if (aif.accountTByAccountId.address1 !== null && aif.accountTByAccountId.address1 !== '') {
          addressFilled = true;
        }

        var primaryContactFilled = false;
        if (aif.accountTByAccountId.contactFirstName !== null && aif.accountTByAccountId.contactFirstName !== ''
              && aif.accountTByAccountId.contactLastName !== null && aif.accountTByAccountId.contactLastName !== '') {
          primaryContactFilled = true;
        }

        var resellerName = "";
        if (this.props.auth.isUnauthenticatedCustomer()) {
          resellerName = aif.accountTByAccountId.accountTByParentId.accountName;
        }

        this.setState({
          accountFetched: true,
          resellerName: resellerName,
          addressFilled: addressFilled,
          primaryContactFilled: primaryContactFilled
        });    
    })
    .catch(err => {
      logError('Exception in FundingSourceList.js: ' + err);
    })
  }

  handleDialogClose = (closeType) => {
    // console.log('handleDialogClose called with close type: ' + closeType);
    if (closeType === 'saved') {
      this.setState({dialogOpen: false, refreshCount: this.state.refreshCount + 1});
    } else {
      this.setState({dialogOpen: false});
    }
  };

  handleActiveMenuClose = () => {
    this.setState({activeMenu: null, rowStatus: null});
  }

  handleActiveMenuClick = (event, count, status) => {
    this.setState({activeMenu: event.currentTarget, rowMenuClicked: count, rowStatus: status});
  }

  handleMenuAction = (ccList, theAction) => {
    let theCC = ccList[this.state.rowMenuClicked];

    if (theAction === 'remove') {
      Promise.resolve().then(() => {
        //console.log('Calling removeCCOnFile');
        return this.removeCCOnFile(theCC);
      }).then(() => {
        //console.log('Setting refreshCount');
        this.setState({activeMenu: null, rowStatus: null, refreshCount: this.state.refreshCount + 1});
      }).catch((error) => {
        //console.log('Error=' + JSON.stringify(error));
        this.setState({activeMenu: null, rowStatus: null});
      });
    } else {
      Promise.resolve().then(() => {
        //console.log('Calling updateCCOnFile');
        return this.updateCCOnFile(theCC, theAction);
      }).then(() => {
        //console.log('Setting refreshCount');
        this.setState({activeMenu: null, rowStatus: null, refreshCount: this.state.refreshCount + 1});
      }).catch((error) => {
        //console.log('Error=' + JSON.stringify(error));
        this.setState({activeMenu: null, rowStatus: null});
      });  
    }
  }

  removeCCOnFile(theCC) {
    const { callPartnerApi } = this.props.auth;
    
    return new Promise(function(resolve, reject) {
      let theResponse = {
        status: -1,
        message: 'Unidentified error'
      };

      Promise.resolve()  
      .then(() => {
        let payload = {
          operation: "removeCC",
          params: {
            "accountId": theCC.accountId,
            "ccId": theCC.ccId,
          }
        }
        //console.log('payload is ' + JSON.stringify(payload));

        return callPartnerApi('appbind/generic',
                              'POST',
                                payload);
      }).then(()=> {
        theResponse.status = 0;
        theResponse.message = 'Success';
        resolve(theResponse);
        return;
      })
      .catch(error => {
        console.log('Caught error: ' + error);
        theResponse.status = -2;
        theResponse.message = 'Error: ' + JSON.stringify(error);
        reject(theResponse);
        return;
      });
    });
  }

  updateCCOnFile(theCC, action) {
    const { callPartnerApi, encryptOneTimeEncryptedValue } = this.props.auth;

    let theStatus = 0;
    if (action === 'activate') {
      theStatus = 0;
    } else if (action === 'suspend') {
      theStatus = 2;
    } else if (action === 'remove') {
      theStatus = 4;
    }

    let cInfo = {
      ccId: theCC.ccId,
      ccStatus: theStatus,
    };

    let cInfoString = JSON.stringify(cInfo);

    return new Promise(function(resolve, reject) {
      let theResponse = {
        status: -1,
        message: 'Unidentified error'
      };

      Promise.resolve()  
      .then(() => {
        // encrypt
        // console.log('encrypting card');
        return encryptOneTimeEncryptedValue(cInfoString, callPartnerApi);
      })
      .then((jresp) => {
        if (jresp != null && jresp.status === 0) {
          let theKeyId = jresp.keyId;
          let encryptedData = jresp.encryptedData;
          let payload = {
            operation: "createOrUpdateCC",
            params: {
              "accountId": theCC.accountId,
              "keyId": theKeyId,
              "encryptedData": encryptedData,
            }
          }
          //console.log('payload is ' + JSON.stringify(payload));

          return callPartnerApi('appbind/generic',
                                'POST',
                                  payload);
        } else {
          console.log('could not use jresp');
          return null;
        }
      }).then(()=> {
        theResponse.status = 0;
        theResponse.message = 'Success';
        resolve(theResponse);
        return;
      })
      .catch(error => {
        console.log('Caught error: ' + error);
        theResponse.status = -2;
        theResponse.message = 'Error: ' + JSON.stringify(error);
        reject(theResponse);
        return;
      });
    });
  }


  render() {
    const classes = this.props.classes;
    const { logError } = this.props.auth;

    let cp = this.props.cp;
    let acctId = this.props.accountId;

    let headerText  = 'Store a card in AppBind';
    let summaryText = 'Store a card in AppBind to make it easier to pay for subscriptions.';

    let ccCount = 0;

    const okColor = green[300];
    const redColor = red[600];
    const yellowColor = yellow[600];

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CCOnFileListQuery}
        variables={{accountId: acctId, refreshCount: this.state.refreshCount}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {
            if (!this.state.accountFetched) {
              return (<div><LoadingSpinner/></div>);
            }

            let theAccount = props.accountTByAccountId;
            let theCCs = theAccount.ccOnFileTsByAccountId.nodes;

            if (theAccount.accountStatus === 1 || theAccount.accountStatus === 2) {
              return (
                <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                  <Grid item xs={12}>
                    <Grid container spacing={0} direction="column" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="h6">{headerText}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">{summaryText}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {theAccount.accountStatus === 1 &&
                    <Grid item xs={12}> 
                      <Typography variant="body2">Account has been suspended.</Typography>
                    </Grid>
                  }
                  {theAccount.accountStatus === 2 &&
                    <React.Fragment>
                      <Grid item  xs={12}> 
                        <Typography variant="body2">In order for you to connect a bank account or credit card, we need to know you a bit better. You can use a government id to verify your identity in less than five minutes!</Typography>
                      </Grid>

                      <Grid item  xs={12}> 
                        <Button color="primary" 
                                variant="contained"
                                onClick={() => { this.goTo('home');}}>
                            Verify account
                        </Button>
                      </Grid>
                    </React.Fragment>
                  }
                </Grid>
              );            
            }

            // active
            if (theAccount.accountStatus === 0) {
              // Reusing the TastTypeCC component, which needs some setup.
              // Create a dummy task object.
              let theTask = {
                assignedAccountId: acctId,
                ccId: null,
                flowTaskId: null,
              };

              let buttonVariant = 'contained';
              if (theCCs.length > 0) {
                buttonVariant = 'outlined';
              }

              return (
                <React.Fragment>
                  <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                    <Grid item xs={12}>
                      <Grid container spacing={0} direction="column" justifyContent="flex-start">
                        <Grid item>
                          <Typography variant="h6">{headerText}</Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body2">{summaryText}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Button color="primary" 
                              variant={buttonVariant}
                              onClick={() => this.setState({dialogOpen: true})}>
                        <Add/>Store a credit card
                      </Button>
                    </Grid>

                    {theCCs.length > 0 &&
                    <Grid item xs={12}>
                      <TableContainer>
                        <Table>
                          <TableHead className={classes.tblHead}>
                            <TableRow className={classes.tblHeadRow}>
                              <TableCell className={classes.tblHeadCell}>Card on file</TableCell>
                              <TableCell className={classes.tblHeadCell}>Added</TableCell>
                              <TableCell className={classes.tblHeadCellN}>Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            { theCCs.map((cc) => {
                              ccCount++;
                              let curCount = ccCount - 1;

                              let theBrand = '';
                              if (cc.ccBrand === 'visa') {
                                theBrand = 'Visa';
                              } else if (cc.ccBrand === 'mastercard') {
                                theBrand = 'MasterCard';
                              } else if (cc.ccBrand === 'american-express') {
                                theBrand = 'American Express';
                              } else if (cc.ccBrand === 'discover') {
                                theBrand = 'Discover';
                              }

                              let addedDate = format(new Date(cc.created), 'yyyy-MM-dd');
                              return (
                                <TableRow key={cc.ccId}>
                                  <TableCell>
                                    <FundingSourceTile 
                                      psType={0}
                                      ccBrand={theBrand}
                                      ccLast4={cc.ccLast4}
                                      ccExpy={cc.ccExpy}
                                      firstName={cc.firstName}
                                      lastName={cc.lastName}
                                    />
                                  </TableCell>
                                  <TableCell>{addedDate}</TableCell>
                                  <TableCell>
                                    <Button
                                      color="primary"
                                      aria-owns={this.state.activeMenu ? 'simple-menu': undefined}
                                      aria-haspopup='true'
                                      onClick={(e) => this.handleActiveMenuClick(e, curCount, cc.ccStatus)}
                                    >
                                      {cc.ccStatus === 0 &&
                                      <CheckCircle htmlColor={okColor}/>}
                                      {cc.ccStatus === 2 &&
                                      <PauseCircleOutline htmlColor={okColor}/>}
                                      {cc.ccStatus === 4 &&
                                      <ReportProblem htmlColor={redColor}/>}

                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>}
                  </Grid>

                  <Menu
                    id="action-menu"
                    anchorEl={this.state.activeMenu}
                    open={Boolean(this.state.activeMenu)}
                    onClose={this.handleActiveMenuClose}>
                    {this.state.rowStatus !== 0 &&
                    <MenuItem onClick={() => {this.handleMenuAction(theCCs, "activate")}}>
                      <ListItemIcon>
                        <PlayCircleOutline />
                      </ListItemIcon>
                      <ListItemText primary="Activate"/>
                    </MenuItem>}
                    {this.state.rowStatus !== 2 &&
                    <MenuItem onClick={() => {this.handleMenuAction(theCCs, "suspend")}}>
                      <ListItemIcon>
                        <PauseCircleOutline />
                      </ListItemIcon>
                      <ListItemText primary="Suspend"/>
                    </MenuItem>}
                    {this.state.rowStatus !== 4 &&
                    <MenuItem onClick={() => {this.handleMenuAction(theCCs, "remove")}}>
                      <ListItemIcon>
                        <CancelCircleOutline htmlColor={redColor}/>
                      </ListItemIcon>
                      <ListItemText primary="Remove"/>
                    </MenuItem>}
                  </Menu>

                  <PaymentSourceDialog
                    title="Add credit card"
                    open={this.state.dialogOpen}
                    onClose={this.handleDialogClose}
                  >
                    <TaskTypeCCWrapper
                      country="US"
                      auth={this.props.auth}
                      task={theTask}
                      done={false}
                      closeAction={this.handleDialogClose}
                      isCompleteDisabled={this.isCompleteDisabled}
                      setCompleteDisabled={this.setCompleteDisabled}
                      ref={(child) => this.child = child}
                    />
                  </PaymentSourceDialog>
                </React.Fragment>
              );
            }

            // Default - treat as 3 (cancelled)
            headerText = 'Account is closed';
            summaryText = 'This account is closed.  There are no cards on file.';
            return (
              <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.sectionBlock}>
                <Grid item xs={12}>
                  <Grid container spacing={0} direction="column" justifyContent="flex-start">
                    <Grid item>
                      <Typography variant="h6">{headerText}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2">{summaryText}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );

          }
          return (<div><LoadingSpinner/></div>);
        }}
      />
    );
  }
}

CCOnFileList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CCOnFileList);